import cn from 'classnames';
import parse from 'html-react-parser';
import { FC, Fragment } from 'react';

import {
  cleanBuilderParagraphInput,
  cleanBuilderStringInput,
  getBuilderString,
} from '@/shared/text';
import { BuilderString } from '@/shared/types';

import style from './List.module.scss';
import { SingleContentType } from './type';

export interface ListItem {
  number: BuilderString;
  content: BuilderString;
}

interface Props {
  type: SingleContentType;
  items?: ListItem[];
  locale: string;
  allowLists?: boolean;
  spacingClassName?: string;
}

export const List: FC<Props> = ({
  type,
  items,
  locale,
  allowLists = false,
  spacingClassName = 'u-m-t-xxl-6',
}) => {
  if (!items) return null;
  if (!items.length) return null;
  if (type !== 'number') return null;

  return (
    <div data-testid="list" className={cn(style.list, spacingClassName)}>
      {items.map((item, index) => {
        const number = getBuilderString(item.number, locale) || `${index + 1}`;
        const text = getBuilderString(item.content, locale) || 'List item';
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            <div
              className={cn(
                style.counter,
                'u-typography-h1-serif',
                'tw:text-brand-primary'
              )}
            >
              {parse(cleanBuilderStringInput(number))}
            </div>
            <span
              className={cn(
                style.content,
                'u-typography-h3',
                'tw:text-neutral-secondary'
              )}
            >
              {parse(cleanBuilderParagraphInput(text, { allowLists }))}
            </span>
          </Fragment>
        );
      })}
    </div>
  );
};
